import { EditOutlined, EyeFilled } from "@ant-design/icons";
import { Button, Col, Pagination, Row, Space, Table } from "antd";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import NotFound from "../../../../components/common/notFound";
import { SUCCESS_CODE } from "../../../../lib/const";
import FailModal from "../../../../components/modal/failModal";
import SuccessModal from "../../../../components/modal/successModal";

import { routes } from "../../../../routes";
import {
  searchCompetitorCustomers,
  getListCompetitor,
} from "../../../../services/customerCompetitor";
import { SearchCompetitorContext } from "../searchContext";

const Content = ({ roleUser }) => {
  const navigate = useNavigate();
  const {
    searchValues,
    setSearchValues,
    pageValues,
    setPageValues,
    search,
    setSearch,
  } = useContext(SearchCompetitorContext);
  let [no, setNo] = useState(0);
  const [dataSource, setDataSource] = useState([]);
  const [successModal, setSuccessModal] = useState(false);
  const [failModal, setFailModal] = useState(false);

  const fetchCompetitorCustomers = useCallback(
    async (searchValues, pageValues) => {
      const res = await searchCompetitorCustomers(searchValues, pageValues);
      const { objectValue, pageValue } = res.data;
      if (res?.data?.code === SUCCESS_CODE) {
        let _p =
          parseInt(pageValues.page) === 0
            ? parseInt(pageValues.page)
            : parseInt(pageValues.page) * pageValues.pageSize;
        setNo(_p);
        setDataSource(objectValue);
        setPageValues({
          ...pageValue,
          sortBy: pageValues.sortBy,
          sortDirection: pageValues.sortDirection,
        });
      } else {
        setDataSource([]);
        setPageValues((prev) => ({
          ...prev,
          page: 0,
          pageSize: 10,
          total: 0,
          totalPage: 0,
        }));
      }
    },
    [setDataSource, setSearchValues, setPageValues]
  );

  useEffect(() => {
    if (search) {
      fetchCompetitorCustomers(searchValues, pageValues);
      setSearch(false);
    }
  }, [fetchCompetitorCustomers, search]);

  const columns = [
    {
      align: "center",
      title: "ลำดับ",
      dataIndex: "no",
      render: () => <span>{(no += 1)}</span>,
    },
    {
      title: "สัญชาติลูกค้า (ประเทศ)",
      dataIndex: "countryId",
      key: "countryId",
      sorter: (a, b) => a.countryId - b.countryId,
      render: (_, record) => {
        return <>{record.countryNameTh}</>;
      },
    },
    {
      title: "สิทธิประโยชน์ทางภาษี",
      dataIndex: "taxBenefit",
      key: "taxBenefit",
      sorter: (a, b) => a.taxBenefit - b.taxBenefit,
      render: (_, record) => {
        return <>{record.taxBenefit}</>;
      },
    },
    {
      title: "อุตสาหกรรมเป้าหมาย",
      dataIndex: "targetIndustry",
      key: "targetIndustry",
      sorter: (a, b) => a.targetIndustry - b.targetIndustry,
      render: (_, record) => (
        <>
          <div>{record.targetIndustry}</div>
        </>
      ),
    },
    {
      title: "ค่าไฟฟ้า",
      dataIndex: "electricityRatePerUnit",
      key: "electricityRatePerUnit",
      sorter: (a, b) => a.electricityRatePerUnit - b.electricityRatePerUnit,
      render: (_, record) => (
        <>
          <div>{record.electricityRatePerUnit}</div>
        </>
      ),
    },
    {
      title: "ค่าน้ำประปา",
      dataIndex: "waterRate",
      key: "waterRate",
      sorter: (a, b) => a.waterRate - b.waterRate,
      render: (_, record) => (
        <>
          <div>{record.waterRate}</div>
        </>
      ),
    },
    {
      title: "ค่าจ้างแรงงานต่อวัน",
      dataIndex: "dailyWage",
      key: "dailyWage",
      sorter: (a, b) => a.dailyWage - b.dailyWage,
      render: (_, record) => (
        <>
          <div>{record.dailyWage}</div>
        </>
      ),
    },
    {
      title: "การจัดการ",
      dataIndex: "action",
      key: "action",
      width: 100,
      render: (_, record) => (
        <Space>
          {roleUser[0]?.isEdit && (
            <Button
              className="btn-edit"
              shape="circle"
              icon={
                <EditOutlined
                  style={{
                    color: record.editable === false ? "lightgray" : "#F79009",
                  }}
                />
              }
              disabled={record.editable === false}
              onClick={() =>
                navigate(routes.edit_customer_competitor + "/" + record.id)
              }
            />
          )}
        </Space>
      ),
    },
  ];

  const onSorter = (pagination, filters, sorter) => {
    setSearch(true);
    setPageValues((prev) => ({
      ...prev,
      sortBy: sorter && sorter.order ? sorter.columnKey : "id",
      sortDirection:
        sorter && sorter.order
          ? sorter.order === "ascend"
            ? "ASC"
            : "DESC"
          : "ASC",
    }));
  };

  const onPageChange = (page, pageSize) => {
    setNo(no + pageSize);
    setSearch(true);
    setPageValues((prev) => ({
      ...prev,
      page: page - 1,
      pageSize: pageSize,
    }));
  };

  return (
    <div style={{ marginTop: 20 }}>
      <p style={{ margin: "30px 0 10px 0", fontWeight: 500 }}>
        รายการทั้งหมด{" "}
        <span className="pr-purple" style={{ fontWeight: 700 }}>
          {pageValues.total}
        </span>{" "}
        รายการ
      </p>

      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Table
            locale={{ emptyText: <NotFound /> }}
            rowKey={"key"}
            dataSource={dataSource}
            columns={columns}
            scroll={{
              x: 1300,
            }}
            pagination={false}
            onChange={onSorter}
          />
        </Col>
        <Col span={24} align="right">
          <Pagination
            showSizeChanger
            defaultCurrent={pageValues.page + 1 || 1}
            total={pageValues.total || 10}
            onChange={onPageChange}
            showTotal={(total) => `รวม ${total} รายการ`}
          />
        </Col>
      </Row>

      <SuccessModal
        open={successModal}
        setOpen={setSuccessModal}
        title={"สำเร็จ"}
        subTitle={"ทำรายการสำเร็จ"}
      />
      <FailModal open={failModal} setOpen={setFailModal} />
    </div>
  );
};

export default Content;
